import type { UseFormReturn } from 'react-hook-form'
import type { EdgeLabelSchemaType } from './agency-node-form.schema'

interface CreateKeyHandlerParams {
  form: UseFormReturn<EdgeLabelSchemaType>
  onSubmit: (values: EdgeLabelSchemaType) => void
  onCancel: () => void
}

export const createEdgeLabelKeyHandler =
  ({ form, onSubmit, onCancel }: CreateKeyHandlerParams) =>
  (e: React.KeyboardEvent): void => {
    if (e.key === 'Enter') {
      e.preventDefault()
      form.handleSubmit(onSubmit)()
      return
    }
    if (e.key === 'Escape') {
      onCancel()
    }
  }
